import { configureStore } from '@reduxjs/toolkit';
import historicalSlice from './historical';

const store = configureStore({
  reducer: {
    historicals: historicalSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export default store;
